import * as types from '../actionTypes/CashpassExclusionsActionTypes';

export default function CashpassExclusionsReducer(
    state = {
        content: null,
        isLoaded: false,
        // Set once a fetch has been attempted (success OR error). Used to stop
        // retrying: on error isLoaded stays false, so without this flag the
        // open-panel effect would re-dispatch the fetch indefinitely.
        hasAttempted: false,
        showLoader: false,
        error: null,
    },
    action = {}
) {
    switch (action.type) {
        case types.GET_CASHPASS_EXCLUSIONS: {
            return { ...state, showLoader: true, error: null };
        }

        case types.GET_CASHPASS_EXCLUSIONS_SUCCESS: {
            return {
                ...state,
                content: action.content,
                isLoaded: true,
                hasAttempted: true,
                showLoader: false,
                error: null,
            };
        }

        case types.GET_CASHPASS_EXCLUSIONS_ERROR: {
            return { ...state, error: action.error, hasAttempted: true, showLoader: false };
        }

        case types.RESET_CASHPASS_EXCLUSIONS: {
            // Keep successfully-cached content as-is (no refetch after success).
            // Only clear the attempt/error state so a prior failure can retry
            // the next time the panel opens.
            if (state.isLoaded) {
                return state;
            }
            return { ...state, hasAttempted: false, error: null, showLoader: false };
        }

        default:
            return state;
    }
}

CashpassExclusionsReducer.reducerName = 'cashpassExclusions';
